import { requestParamsByDashboardSortType } from "~/feature/dashboard/components/sortAndFilters/SortBy/constants";
import { DashboardSortType } from "~/feature/dashboard/components/sortAndFilters/SortBy/types";
import type { DashboardSortState } from "~/providers/FilterProvider";

export const getSortByLabel = (sort: DashboardSortState) => {
  if (sort.sortBy && sort.sortOrder) {
    const matched = Object.values(DashboardSortType).find((type) => {
      const requestParams = requestParamsByDashboardSortType[type];
      return (
        requestParams.sortBy === sort.sortBy &&
        requestParams.sortOrder === sort.sortOrder
      );
    });
    return matched ?? null;
  }

  return null;
};
